import { __, Alert } from "modules/theme";
import React, { Component } from "react";
import PropTypes from "prop-types";
import APIManager from "modules/common/apiManager";
import {
  FormControl,
  FormGroup,
  ControlLabel,
  ModalFooter,
  Button,
  ButtonCommonTheme,
} from "modules/theme";
import { FormWrapper, FormColumn } from "modules/theme";
import { ModalForm, ModalFormContainer } from "../../../../theme";
import Select from "react-select-plus";
import { isAccess } from "../../../../common/utils";
import { debounce } from "../../../../../helpers/common";
import Creatable from "react-select-plus/lib/Creatable";

export class TTSProviderAddEdit extends Component {
  constructor(props) {
    super(props);
    this.moduleName = `TTS Provider`;
    this.moduleUrl = `config/tts/provider`;
    this.saveData = this.saveData.bind(this);
    this.renderFormGroup = this.renderFormGroup.bind(this);
    this.mAPI = new APIManager();
    this.setData(this.props.editData);
    // this.state = {
    //   options: [],
    // };
  }
  setData(editData = {}) {
    console.log("editData", this.props.tagList);
    editData = editData || {};
    this.state = {
      isLoading: false,
      type: editData.name || "",
      label: editData.label || "",
      price: editData.price || "",
    };
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  resetAllData() {
    this.setState({
      type: "",
      label: "",
      price: "",
    });
  }

  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      // Alert.success(`${data.message}`);
      let message = data && data.message ? data.message : "Successfully Done";
      Alert.success(`${message}`);
      this.resetAllData();
      this.props.closeModal(true);
    } else {
      // Alert.error(`${data.message}`);
      let message =
        data && data.message ? data.message : "Something wrong happened";
      Alert.error(`${message}`);
      this.setState({ isLoading: false });
    }
  }

  saveData(e) {
    e.preventDefault();
    this.setState({ isLoading: true });
    let _this = this;
    let label = this.state.label.trim() || "";
    let tData = {
      type: this.state.type,
      label: label,
      price: this.state.price,
    };
    if (this.props.editData && this.props.editData._id) {
      this.mAPI.sendPostAPI(
        `${this.moduleUrl}/${this.props.editData._id}`,
        tData,
        (data) => {
          console.log(JSON.stringify(data, null, 2));
          if (data) {
            _this.resetAllData();
            _this.props.closeModal(true);
            Alert.success(`${this.moduleName} updated successfully.`);
          }
          this.setState({ isLoading: false });
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        },
        "public",
        { id: this.props.editData._id },
        "PATCH"
      );
    } else {
      this.mAPI.sendPostAPI(
        `${this.moduleUrl}`,
        tData,
        (data) => {
          _this.setData();
          _this.props.update();
          _this.props.closeModal(true);
          Alert.success(`${this.moduleName} created successfully.`);
          _this.setState({ isLoading: false });
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
          this.setState({ isLoading: false });
        },
        "public"
      );
    }
  }

  render() {
    const { modalType } = this.props;
    const exceptThisSymbols = ["e", "E", "-"];
    const re = /^[\.0-9]*$/;
    return (
      <ModalForm onSubmit={(e) => this.saveData(e)}>
        <ModalFormContainer>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("Display Name", {
                defaultValue: "",
                placeholder: "Display Name",
                autoFocus: true,
                required: true,
                id: "label",
                value: this.state.label,
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  let label =
                    e.target.value && e.target.value.trim() == ""
                      ? ""
                      : e.target.value;
                  this.setState({
                    label: label,
                  });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("Type", {
                defaultValue: "",
                placeholder: "Type",
                autoFocus: false,
                required: true,
                id: "type",
                disabled:
                  this.props.editData && this.props.editData._id ? true : false,
                value: this.state.type,
                onChange: (e) => {
                  if (e.target.value === " ") {
                    return false;
                  }
                  this.setState({
                    type: e.target.value,
                  });
                },
              })}
            </FormColumn>
          </FormWrapper>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup("Price", {
                defaultValue: "",
                placeholder: "Price",
                autoFocus: false,
                required: true,
                id: "price",
                value: this.state.price,
                onKeyDown: (e) => {
                  exceptThisSymbols.includes(e.key) && e.preventDefault();
                },
                onChange: (e) => {
                  if (
                    !re.test(e.target.value)
                  ) {
                    return false;
                  }
                  this.setState({ price: e.target.value });
                },
                // onChange: (e) => {
                //   if (e.target.value === " ") {
                //     return false;
                //   }
                //   this.setState({
                //     price: e.target.value,
                //   });
                // },
              })}
            </FormColumn>
          </FormWrapper>
        </ModalFormContainer>
        <ModalFooter modalType={modalType}>
          <ButtonCommonTheme
            type="greyModalBtn"
            // btnStyle="cancel"
            OnClick={() => this.props.closeModal()}
            size="xl"
            modalBtnTitle="Cancel"
          />
          <ButtonCommonTheme
            type="blueModalBtn"
            btnType="submit"
            isLoading={this.state.isLoading}
            disabled={this.state.isLoading}
            modalBtnTitle={
              this.props.editData && this.props.editData._id ? "Update" : "Add"
            }
          />
        </ModalFooter>
      </ModalForm>
    );
  }
}

TTSProviderAddEdit.propTypes = {
  group: PropTypes.array,
};

TTSProviderAddEdit.contextTypes = {
  __: PropTypes.func,
  closeModel: PropTypes.func.isRequired,
};

export default TTSProviderAddEdit;



// WEBPACK FOOTER //
// src/modules/screens/Org_setting/TTSProvider/components/TTSProviderAddEdit.js